import { shallowEqual, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useAppSelectorShallow<T>(selector: (state: RootState) => T): T {
  return useSelector(selector, shallowEqual);
}
